import styled from "styled-components";
import { H5 } from "components/Typography";

const DisclaimerMessageContentText = styled(H5)`
	margin: 0 auto 24px auto;
	text-align: center;
	font-weight: 600;
`;

export default DisclaimerMessageContentText;